import React from 'react';
import { FiEdit2, FiTrash2 } from 'react-icons/fi';

import { CouponsModels } from '../../../../../models/CouponsModels';
import {
  DataTable,
  DataTableColumn,
  IconButton,
  StatusBadge,
} from '../../../../../components/Admin';

import { ICuponsTable } from './types';
import { ActionsContainer, Code, Muted } from './styles';

const brl = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });

/** `discount` diz o tipo: "%" (percentual) ou "$" (valor fixo em reais). */
const formatDiscount = (coupon: CouponsModels) => {
  const value = Number(coupon.value ?? 0);
  if (coupon.discount === '%') return `${value}%`;
  if (coupon.discount === '$') return brl.format(value);
  return String(coupon.value ?? '—');
};

const isSoldOut = (coupon: CouponsModels) =>
  coupon.quantity != null && Number(coupon.usage ?? 0) >= Number(coupon.quantity);

const CouponsTable: React.FC<ICuponsTable> = ({
  data,
  courseTitles,
  deletingId,
  onEdit,
  onDelete,
}) => {
  const productName = (coupon: CouponsModels): string | undefined => {
    if (coupon.productid === 'all') return 'Todos os cursos';
    return courseTitles[coupon.productid];
  };

  const columns: DataTableColumn<CouponsModels>[] = [
    {
      key: 'code',
      header: 'Código',
      align: 'start',
      render: coupon => <Code>{coupon.couponid}</Code>,
    },
    {
      key: 'product',
      header: 'Curso',
      align: 'start',
      render: coupon =>
        productName(coupon) ?? <Muted title="Curso não encontrado">{coupon.productid}</Muted>,
    },
    {
      key: 'discount',
      header: 'Desconto',
      render: formatDiscount,
    },
    {
      key: 'usage',
      header: 'Utilizados',
      render: coupon => `${coupon.usage ?? 0} de ${coupon.quantity ?? '—'}`,
    },
    {
      key: 'status',
      header: 'Status',
      render: coupon =>
        isSoldOut(coupon) ? (
          <StatusBadge label="Esgotado" tone="neutral" />
        ) : (
          <StatusBadge label="Disponível" tone="positive" />
        ),
    },
    {
      key: 'actions',
      header: 'Ações',
      render: coupon => (
        <ActionsContainer>
          <IconButton label={`Editar o cupom ${coupon.couponid}`} onClick={() => onEdit(coupon)}>
            <FiEdit2 size={16} />
          </IconButton>
          <IconButton
            tone="danger"
            label={`Excluir o cupom ${coupon.couponid}`}
            disabled={!!deletingId}
            onClick={() => onDelete(coupon)}
          >
            <FiTrash2 size={16} />
          </IconButton>
        </ActionsContainer>
      ),
    },
  ];

  return (
    <DataTable
      columns={columns}
      rows={data}
      rowKey={coupon => coupon.couponid}
      emptyMessage="Nenhum cupom encontrado."
    />
  );
};

export default CouponsTable;
